<script type="text/javascript">

	import VueEasyLightbox from "vue-easy-lightbox";
	import { EventBus } from "../../../../app";
	import DefaultContentRelatedProductsSwiper from "../../../../components/widgets/page-builder/templates/actinolite/DefaultContent-RelatedProductsSwiper";
	import Login from "../../../../public-views/account/onpageLogin";
	import SocialShareBlock from "../../../../components/widgets/page-builder/widgets/web/SocialShareBlock";
	export default{
		data(){
			return {
				share: false,
				quantity: 1,
				previewImgBtns: false,
				showLightbox: false,
				imgView: null,
				imgViewIndex: 0,
				hoverIndex: -1,
				hoverLink: -1,
				loadingVariants: false,
				lightboxImages: [],
				selectedvariantstotal: 0.00,
				selectedvariants: {},
				selectedcombination: null,
				product: [],
				routearray: [],
				storageurl: '/image',
				form: {
					action: '',
					name: '',
					lastname: '',
					email: '',
					customer_uid: '',
					share_details: '',
					review: '',
					message: '',
					review_score: 0,
				},
				imgswiperOptions: {
		          slidesPerView: 5,
		          spaceBetween: 10,
		          pagination: {
		            el: '.swiper-pagination',
		            clickable: true
		          },
		          navigation: {
		            nextEl: '.swiper-button-next',
		            prevEl: '.swiper-button-prev'
		          }

		        },
		        swiperOptions: {
		          slidesPerView: 4,
		          spaceBetween: 30,
		          autoplay: {
				      delay: 2500,
				      disableOnInteraction: false
				    },
		          loop: false,
		          loopFillGroupWithBlank: false,
		          pagination: {
		            el: '.swiper-pagination',
		            clickable: true,
		          },
		          // Some Swiper option/callback...
		        },
			}
		},
		props: {
			company: {
				type: Object
			},
			resource: {
				type: String,
				default: () => 'product'
			},
			product: {
				type: Object
			},
			user: {
				type: Object
			}
		},
		components: {
			SocialShareBlock,
			VueEasyLightbox,
			Login,
			DefaultContentRelatedProductsSwiper
			
		},
		created(){
			//this.getResource(this.resource);
		},
		methods: {
			submitReview(uid){
				axios.post('/customer-api/product/'+uid+'/submit-review', this.form, {headers: {'Authorization' : 'Bearer '+this.user.api_token}}).then(response => {
					this.product.reviews.push(response.data);
					let self = this;
					setTimeout(function(){
						self.success_message = true;
						self.success_message_text = 'Your review has been submitted';
						self.loadReviews = false;
					}, 500);
				}).catch({

				});
			},
			isKeyValueActive(key, value){
				if(this.selectedvariants[key] == value){
					return true;
				}else{
					return false;
				}
			},
			addToCart(product, quantity, variant, combination){
		    	EventBus.$emit('add-to-cart', product, quantity, variant, combination);
		    },
			/**getResource(resource){
				this.routearray = this.$route.path.substring(1).split('/');
				axios.get('/website-api/widget/'+resource+'/'+this.routearray[this.routearray.length-1]).then(response => {
					this.product = response.data;
					
				}).catch(error => {
					this.product = [];
					console.log(error);
				});
			},**/
			imageSelected(img){
		    	if(this.imgView == null){
		    		this.product.images.unshift(this.product.cover_image);
		    	}
		    	this.imgView = img;
		    },
		    calculateVariantsTotal(){
        		var total = 0.00;
        		for(let key in this.selectedvariants){
        			console.log(key);
        			total += parseFloat(this.selectedvariants[key].price_difference);
        		}
        		this.selectedvariantstotal = this.addTax(this.product.tax_rule, total);
        	},
        	addTax(rule, price){
            var tax_rule = rule;
            console.log(tax_rule);
            var country_id = this.company.country_id;
       
          if(tax_rule !== null && tax_rule.country_rules.length > 0){
            var selected_rule = null;
            var selected_ruleIndex = -1;
            for(var ti = 0; ti < tax_rule.country_rules.length; ti++){
              selected_ruleIndex = tax_rule.country_rules[ti].countries.findIndex(item => item == country_id);
              if(selected_ruleIndex !== -1){
                selected_rule = tax_rule.country_rules[ti];
                ti = tax_rule.country_rules.length;
              }
            }
            console.log(selected_rule);
            if(tax_rule.type == 1){
                if(selected_rule !== null){
                  var percentage = (parseFloat(selected_rule.value) / 100) + 1;
                  this.active_tax_percentage = percentage;
                  return price * percentage;
                }else{
                  return price;
                }
              }else{
                if(selected_rule !== null){
                  this.active_tax_percentage = selected_rule.value;
                  return price + selected_rule.value;
                }else{
                  return price;
                }
              }
            }else if(tax_rule !== null && tax_rule.country_rules.length > 0){
              var percentage = (parseFloat(tax_rule.percentage) / 100) + 1;
              return price * percentage;
            }else {
              return price;
            }
          },
		    setUpLightbox(){
		    	//this.product.images = JSON.parse(JSON.stringify(this.product.images).replaceAll('caption', 'title'));
		    		var image = {};
		    		image["src"] = ''+this.storageurl+''+this.product.cover_image.src.replaceAll('//', '/')+'';
		    		image["title"] = this.product.cover_image.caption;
		    		this.lightboxImages.push(image);
		    	for(var i = 0; i < this.product.images.length; i++){
		    		var image = {};
		    		image["src"] = ''+this.storageurl+''+this.product.images[i].src.replaceAll('//', '/')+'';
		    		image["title"] = this.product.images[i].caption;
		    		console.log(image);
		    		this.lightboxImages.push(image);
		    		if(this.imgView == this.product.images[i]){
		    			this.imgViewIndex = (this.lightboxImages.length - 1);
		    		}
		    	}
		    	

		    },
		},
		  watch: {
        $route() {
        	this.$nextTick(() => {
        		 //this.loadingPage = true;
        		 this.getResource(this.resource);

        		});
        	}
        },
        computed: {
        	variantsTotal(){
        		var total = 0.00;
        		for(let key in this.selectedvariants){
        			console.log(key);
        			total =+ parseFloat(this.selectedvariants[key].price_difference);
        		}
        		return total;
        	},
        	priceIncVat(){
        		if(this.product.tax_rule !== null){
        			var percentage = (parseFloat(this.product.tax_rule.percentage) / 100) + 1;
        			return (this.product.sales_price * percentage);
         		}else{
         			return this.product.sales_price;
         		}
        	},
        	combinationPrice(){
        		if(this.selectedcombination !== null){
        		return parseFloat(this.selectedcombination.price_difference);
        		}else{
        			return parseFloat(0.00);
        		}
        	}
        }
	}

</script>
<template>
	<b-container fluid class="py-4 my-4 default-content">
		<vue-easy-lightbox
                :visible="showLightbox"
                :imgs="lightboxImages"
                :index="imgViewIndex"
                @hide="showLightbox = !showLightbox"
              ></vue-easy-lightbox>
		<b-row class="mb-4">
			<b-col md="6" class="px-3 overflow-hidden">
				<a class="position-relative d-block" @mouseenter="previewImgBtns = true" @mouseleave="previewImgBtns = false" @click="setUpLightbox(), showLightbox = !showLightbox">
					<div  v-if="(product.cover_image !== null) && (imgView == null)">
					
                  <img
                  v-if="'gallery' in product.cover_image" 
                  	 :src="storageurl + product.cover_image.gallery.replaceAll('//','/')"
                    alt
                    class="img-fluid w-100 border mb-3"
                  />
                  <img
                  v-else-if="'src' in product.cover_image" 
                  	 :src="storageurl + product.cover_image.src.replaceAll('//','/')"
                    alt
                    class="img-fluid w-100 border mb-3"
                  />
                  <img
                  v-else-if="'thumb' in product.cover_image" 
                  	 :src="storageurl + product.cover_image.thumb.replaceAll('//','/')"
                    alt
                    class="img-fluid w-100 border mb-3"
                  />
				</div>
				<img v-else-if="imgView !== null" :src="storageurl + imgView.src.replaceAll('//', '/')" class="img-fluid w-100 border mb-3"> 
				<img v-else src="/images/product-placeholder.png" class="img-fluid w-100 border mb-3">
				<transition name="fade-right">
				   <div class="position-absolute top-0 right-0 mt-3 mr-3 rounded" v-if="previewImgBtns == true">
	                          	<a class="btn btn-primary rounded-circle bg-peach-soft" href="javascript:;">
	                          		<i class="bx bx-search"></i>
	                          	</a>
	                </div>
	            </transition>
				</a>
				<ImageSwiper :swiperOptions="imgswiperOptions" :items="product.images" @image-selected="imageSelected" :company="product.company" :imgClass="'border'" :isAdmin="true" ></ImageSwiper>
			</b-col>
			<b-col md="6" class="px-3 d-flex flex-column">
				<SocialShareBlock />
				
				<p class="mb-2 text-muted font-size-14">REFERENCE: {{product.reference}}</p>
				<h1 class="text-capitalize mb-3">{{product.name}}</h1>
				<div class="d-flex">
				<b-form-rating id="rating-inline" variant="warning" inline no-border size="lg"></b-form-rating>
				
				
				</div>
				<p class="mb-3" v-html="product.short_description"></p>
				<h4 class="font-size-28 mb-4" v-if="product.combinations.length == 0"><span class="currency">£</span>{{(addTax(product.tax_rule, product.price_exc) + parseFloat(selectedvariantstotal)).toFixed(2)}}</h4>
				<h4 v-else class="font-size-28 mb-4"><span class="currency">£</span>{{(addTax(product.tax_rule, product.price_exc) + parseFloat(combinationPrice)).toFixed(2)}}</h4>

				<!--<h5 class="text-uppercase font-size-12 text-underline spaced-title mt-2 pt-3">Product Features</h5>
				<b-row>
				     <div class="col-md-12" v-if="product.attributes.length == 0">
                    <b-card class="shadow-none text-center border mb-2 py-4">
                      <i class="bx bxs-cube font-size-24 text-muted"></i>
                      <h4>No Active Features</h4>
                  </b-card>
                  </div>
                 <div class="col-md-12 mb-2" v-if="product.attributes.length !== 0">
                <div class="row">
               <div class="col-md-12">
                <div class="form-control-group">
                <b-list-group class="list-group" flush>
                <li v-for="(active_attributes, index) in product.attributes" class="list-group-item p-0 d-flex py-3">
                <span class="my-auto pl-4 w-25">
                  <img v-if="active_attributes.attribute.image" :src="active_attributes.attribute.image" class="avatar-xs rounded-circle mr-2">
                  <img v-else src="/images/product-placeholder.png" class="avatar-xs rounded-circle mr-2">
                {{active_attributes.attribute.name}}
              </span>
              <span class="w-25">
                <img v-if="active_attributes.value.image" :src="active_attributes.value.image" class="avatar-xs rounded-circle mr-3">
                <img v-else src="/images/product-placeholder.png" class="avatar-xs rounded-circle ml-2 mr-2"> {{active_attributes.value.name}}
              </span>
              <span class="my-auto pl-4 w-50 d-flex">
              	<span class="ml-auto">{{active_attributes.measurement_value}}{{active_attributes.units.suffix}}
              	</span>
              </span>
              
			          </li>
			        </b-list-group>
			      </div>
			    </div>
			  </div>
			</div> 
			</b-row>-->
			<div class="border-top pt-3" v-if="product.combinations.length == 0" >
					<h5 class="text-uppercase font-size-12 text-underline spaced-title mb-4">Select Customisation Options</h5>
				<div class="w-100" v-for="(variants, key) in product.grouped_variants">
					<h5 class="text-uppercase font-size-12 spaced-title">{{variants[0].attribute.name}}</h5>
					<b-row >
						<b-col md="4" v-for="value in variants">
						<b-overlay :show="loadingVariants">
							<a href="javascript:;" @click="selectedvariants[key] = value, calculateVariantsTotal(), loadingVariants = true, loadingVariants = false" >
							<b-card class="border-radius-1em border shadow-none text-dark mb-3" body-class="d-flex" :class="{'border-primary' : selectedvariants[key] == value}">
								<span class="my-auto" v-if="value.value !== null"><img v-if="value.value.image !== null" :src="value.value.image" class="avatar-xs rounded-circle mr-2 border"> 
								</span>
								<span class="my-auto mr-2" v-if="value.value !== null">{{value.value.name}}</span> <span class="my-auto">{{value.measurement_value}}</span><span class="my-auto mr-2" v-if="value.units !== null">{{value.units.suffix}}</span>
								<span class="badge badge-light bg-light my-auto ml-auto font-size-14">
								<span class="ml-auto my-auto" v-if="value.price_difference > 0">+</span><span class="ml-auto my-auto" v-else>-</span><span class="currency">£</span>{{value.price_difference}}
								</span>
							</b-card>
							</a>
						</b-overlay>
						</b-col>
					</b-row>
				</div>
			</div>
				<div v-else >
					<h5 class="text-uppercase font-size-12 text-underline spaced-title mt-2 pt-3">Select Customisation Options</h5>
				<div class="w-100" v-for="(combination, index) in product.combinations">
					<a href="javascript:;" @click="selectedcombination = combination" >
						<b-card class="border-radius-1em border shadow-none text-dark" :class="{'border-primary' : selectedcombination == combination}">
					<b-row>
						<b-col md="3" v-for="value in combination.variants">
							
							
								<span v-if="value.variant.attribute !== null">{{value.variant.attribute.name}}</span> 
								<span v-if="value.variant.value !== null">{{value.variant.value.name}}</span> {{value.variant.measurement_value}}<span v-if="value.variant.units !== null">{{value.variant.units.suffix}}</span>
								
								
							
							
						</b-col>
						<b-col md="12" class="d-flex">
							<span class="badge badge-light bg-light ml-auto mt-2 font-size-14">
							<span v-if="combination.price_difference > 0">+</span><span v-else>-</span><span class="currency">£</span>{{combination.price_difference}}
								</span>
						</b-col>
					</b-row>
					</b-card>
					</a>
				</div>
				</div>
				<div class="d-flex mb-2">
					 <b-button variant="-light" :disabled="quantity < 2" id="tooltip-add" @click="quantity--" class="btn btn-light font-size-16 btn-rounded w-25 mr-1 my-auto"><i class="mdi mdi-minus"></i></b-button>
					  <b-form-group label="" class="w-50 my-auto mx-1">
						<b-form-input type="number" v-model="quantity" size="lg" /></b-form-group>
					  <b-button variant="-light" :disabled="quantity >= product.total_qty " @click="quantity++" class="btn btn-light font-size-16 btn-rounded w-25 my-auto m1-1"><i class="mdi mdi-plus"></i></b-button>
				</div>
				<div class="d-flex">
					<b-button variant="primary" class="btn-rounded btn-block w-100 text-white btn-lg" @click="addToCart(product, quantity, selectedvariants, selectedcombination)">
					Add to Cart
					</b-button>	
					<!--<a class="btn btn-primary my-auto btn-rounded w-75"  >Add to Cart</a>-->
				</div>
				<div class="d-flex mt-auto pt-4 w-100">
					<b-card class="border-radius-1em border shadow-none w-100">
						 <h4>Sold By</h4>
						 <hr>
						 <div class="d-flex">
						 		<div class="" v-if="company.logo !== null">
						 			<img :src="storageurl + company.logo.replaceAll('//', '/').replaceAll('https:/'+company.nickname+'.s3.eu-west-2.amazonaws.com', '')" class="avatar-md rounded-circle border mr-4">
						 		</div>
						 		<div class="d-flex flex-column">
						 			<h5 class="mb-1 mt-auto">{{company.name}}</h5>
						 			<p>{{company.description.slice(0, 175)}}...</p>
						 			<router-link class="btn btn-light my-auto btn-rounded" :to="'/seller/'+company.nickname+'/profile'">
						 				See Products <i class="bx bx-store"></i>
						 			</router-link>
						 		</div>
						 		
						 </div>
					</b-card>
				</div>
			</b-col>
		</b-row>
		<b-row>
			<b-col md="12" class="d-flex mt-4">
				<h2 class="product-info-header">More Information</h2>
				<hr class="mb-4 flex-grow-1">
			</b-col>
			<b-col md="6" class="offset-md-6">
				<p class="mt-3 px-3" v-html="product.long_description"></p>
			</b-col>
			<b-col md="12" class="d-flex mt-4">
				<h2 class="product-info-header">Features</h2>
				<hr class="mb-4 flex-grow-1">
			</b-col>
			<b-col md="6" class="offset-md-6">
				
				<b-row>
				     <div class="col-md-12" v-if="product.attributes.length == 0">
                    <b-card class="shadow-none text-center border mb-2 py-4">
                      <i class="bx bxs-cube font-size-24 text-muted"></i>
                      <h4>No Active Features</h4>
                  </b-card>
                  </div>
                 <div class="col-md-12 mb-2" v-if="product.attributes.length !== 0">
                <div class="row">
               <div class="col-md-12">
                <div class="form-control-group">
                <b-list-group class="list-group" flush>
                	<div v-for="attribute_group in product.grouped_attributes">
                	   <li v-for="(active_attributes, index) in attribute_group" class="list-group-item p-0 d-flex py-3">
		                <span class="my-auto pl-4 w-25">
		                  <!--<img v-if="active_attributes.attribute.image" :src="active_attributes.attribute.image" class="avatar-xs rounded-circle mr-2">
		                  <img v-else src="/images/product-placeholder.png" class="avatar-xs rounded-circle mr-2">-->
		               <div v-if="index == 0">{{attribute_group[0].attribute.name}}</div>
		              </span>
		              <span class="w-25">
		                <img v-if="active_attributes.value.image" :src="active_attributes.value.image" class="avatar-xs rounded-circle mr-3 border">
		                 {{active_attributes.value.name}}
		              </span>
		              <span class="my-auto pl-4 w-50 d-flex">
		              	<span class="ml-auto">{{active_attributes.measurement_value}}{{active_attributes.units.suffix}}
		              	</span>
		              </span>
		              
					          </li>
			        </div>
			        </b-list-group>
			      </div>
			    </div>
			  </div>
			</div> 
			</b-row>
			</b-col>
			<b-col md="12" class="d-flex mt-4">
				<h2 class="product-info-header">Reviews</h2>
				<hr class="mb-4 flex-grow-1">
			</b-col>
			<b-col md="6" class="offset-md-6">
				<b-row v-if="product.reviews.length > 0">
					<b-col v-for="review in product.reviews">
					<b-card class="border border-radius-1em shadow-none">
						<blockquote class="p-3">{{review.message}}</blockquote>
						<b-form-rating readonly v-model="review.rating">
						</b-form-rating>
						<h6>
							{{review.name}} 
							{{review.lastname}}
						</h6>
						<small>
							{{review.created_at}}
						</small>
					</b-card>
					</b-col >
					
				</b-row>
				<b-row>
					<b-col md="12" class="text-center py-4">
						<i class="bx bx-star text-warning d-inline-block font-size-14"></i>
						<i class="bx bx-star text-warning d-inline-block font-size-20"></i>
						<i class="bx bx-star text-warning d-inline-block font-size-28"></i>
						<i class="bx bx-star text-warning d-inline-block font-size-20"></i>
						<i class="bx bx-star text-warning d-inline-block font-size-14"></i>
						<h4 class="text-muted">
							No Reviews
						</h4>
						<!--<a class="text-primary" href="javascript:;">
							Be the first to review this product
						</a>-->
						<a class="btn btn-light btn-rounded mb-2"  v-b-modal.modal-1 @click="form.action = 'review'">Be the first to review this product <i class="bx bx-star text-warning"></i></a>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
		<!--<b-row>
			<b-col md="12" class="d-flex mt-4">
				<h2 class="product-info-header">Related Products</h2>
				<hr class="mb-4 flex-grow-1">
			</b-col>
			<b-col md="8" class="offset-md-4 overflow-hidden">
				<DefaultContentRelatedProductsSwiper :swiperOptions="swiperOptions" :items="product.related_products">
				</DefaultContentRelatedProductsSwiper>

			</b-col>
		</b-row>-->
		<b-row class="mt-4 py-4">
			<b-col md="12" class="mt-4 overflow-hidden">
				<h2 class="product-info-header">Related Products</h2>
				<hr class="mb-4 flex-grow-1">
				<div class="pt-5">
				<DefaultContentRelatedProductsSwiper :swiperOptions="swiperOptions" :items="product.related_products" :startSlide="0">
				</DefaultContentRelatedProductsSwiper>
				</div>
			</b-col>
		</b-row>
		<b-row class="mt-4 py-4">
			<b-col md="12" class="mt-4 overflow-hidden">
				<h2 class="product-info-header">You Recently Viewed</h2>
				<hr class="mb-4 flex-grow-1">
				<div class="pt-5">
				<DefaultContentRelatedProductsSwiper  :swiperOptions="swiperOptions" :items="product.related_products" :startSlide="0">
				</DefaultContentRelatedProductsSwiper>
				</div>
			</b-col>
		</b-row>
		<b-modal id="modal-1" centered content-class="border-radius-1em" header-class="border-none" hide-footer>
			<b-card-body class="card-body pt-0">
            <div class="row">
            	<div class="col-sm-12 pb-4 text-center mb-4">
            		<h3>You are about to {{form.action}}</h3>
            	</div>
              <div class="col-sm-12 pb-4 text-center border border-radius-1em">
                <div class="avatar-md profile-user-wid mb-2 mx-auto" v-if="product.cover_image !== null" >
                  <img
                  v-if="'thumb' in product.cover_image" 
                  	 :src="storageurl + product.cover_image.thumb"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                  <img
                  v-else-if="'gallery' in product.cover_image" 
                  	 :src="storageurl + product.cover_image.gallery"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                  <img
                  v-else-if="'src' in product.cover_image" 
                  	 :src="storageurl + product.cover_image.src"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                   <span v-else class="avatar-title rounded-circle font-size-16 bg-light text-primary">{{product.name.slice(0,1)}}</span>
                </div>
                <div v-else class="avatar-md profile-user-wid mb-2 mx-auto">
                	<span class="avatar-title rounded-circle font-size-16 bg-light text-primary">{{product.name.slice(0,1)}}</span>
                </div>
                <h5 class="font-size-15 text-truncate">{{product.name}}</h5>
                <p class="text-truncate font-size-12 mb-0 px-3" v-html="product.short_description"></p>
              </div>
           

            </div>
          </b-card-body>
    <b-form v-if="form.action == 'message'">
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="First Name" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="Last Name" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="Email" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="Telephone" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group>
    		<b-form-textarea
    		class="underline-input my-2"
		      id="textarea"
		      placeholder="Enter something..."
		      rows="4"
		    ></b-form-textarea>
    	</b-form-group>
    	<a class="btn btn-outline-light btn-rounded btn-block mt-3" href="javascript:;">Send Message</a>
    </b-form>

    <b-form v-if="(form.action == 'review') && (user)" class="px-2">
    	<b-form-group class="text-center">
    	<label class="mt-3 text-center">Your Details</label>
    </b-form-group>
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="First Name" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="Last Name" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group>
    		<b-form-input class="underline-input my-2" placeholder="Email" type="text"></b-form-input>
    	</b-form-group>
    	<b-form-group class="text-center">
    		 <label for="rating-lg-no-border" class="mt-3">Your Rating</label>
    			<b-form-rating id="rating-lg-no-border" variant="warning" v-model="form.review_score" class="text-center" no-border size="lg"></b-form-rating>
    	</b-form-group>
    	<b-form-group>
    		<b-form-textarea
    		class="underline-input my-2"
		      id="textarea"
		      placeholder="Enter review comments"
		      rows="4"
		    ></b-form-textarea>
    	</b-form-group>
    	<a class="btn btn-outline-light btn-rounded btn-block mt-3" @click="submitReview(product.uid)">Submit Review</a>
    </b-form>
    <b-form v-if="(form.action == 'favourites')  && (user !== null)" class="px-2">
    </b-form>

    <b-form v-if="((form.action == 'favourites') || (form.action == 'review')) && (!user)" class="px-2">
    	<!--<a class="btn btn-outline-light btn-rounded btn-block mb-2" target="_blank">Sign In</a>-->
    	<Login submit-url="https://gemesys.co.uk/my-account/login" auth-error="">
             <input type="hidden" name="_token" :value="csrf">
        </Login>
        
    </b-form>
  </b-modal>
	</b-container>
</template>


<style scoped >
#rating-inline{
	display: inline !important;
    padding: 0;
    width: auto !important;
}
#rating-inline .b-rating-star{
	padding: 0 5px 0 0 !important;
}
.spaced-title{
	letter-spacing: 0.9px;
}
</style>